<div class="d-flex flex-column flex-md-row justify-content-md-between align-items-start mb-2">
    <div class="d-flex flex-column col-12 col-md-4 mt-3">
        <span class="mb-3"><b>{{ availableListName | i18next }}</b></span>
        <p-listbox
          [options]="availableItemsList"
          scrollHeight="144px"
          optionLabel="label"
          [filter]="true"
          filterBy="label"
          [disabled]="disabled"
          filterPlaceHolder="{{ 'list-select_search_placeholder' | i18next }}"
          (onChange)="selectItems($event.value)">
        </p-listbox>
    </div>
    <div class="d-flex flex-column col-12 col-md-7 mt-4 mt-md-3">
        <span class="mb-3"><b>{{ selectedListName | i18next }}</b></span>
        <p-scrollpanel [style]="{ width: '100%', height: '200px', border: '1px solid #ccc', 'border-radius': '6px', padding: '0.5rem'}">
            <div class="d-flex flex-wrap gap-2">
            @for (item of selectedItemsList; track item.id) {
                <p-chip
                  [label]="item.label"
                  [removable]="!disabled"
                  (onRemove)="removeItem(item)">
                </p-chip>
            }
            </div>
        </p-scrollpanel>
    </div>
</div>